import { AppConstants, RegexConstants } from "../../../../constants/constant";

function IdentifyCountryCode(postalCode) {
  if (RegexConstants.US_ZIP_CODE_REG?.test(postalCode)) {
    return AppConstants.COUNTRY_US;
  }
  if (RegexConstants.CA_ZIP_CODE_REG.test(postalCode)) {
    return AppConstants.COUNTRY_CA;
  }
}

export default IdentifyCountryCode;
